import MaterialIconCode from "!!raw-loader!./icons/MaterialIcon.tsx";
import FontAwesomeIconCode from "!!raw-loader!./icons/FontAwesomeIcon.tsx";
import SvgIconCode from "!!raw-loader!./icons/SvgIcon.tsx";
import IconRTLCode from "!!raw-loader!./icons/IconRTL.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import MaterialIcon from "./icons/MaterialIcon";
import FontAwesomeIcon from "./icons/FontAwesomeIcon";
import SvgIcon from "./icons/SvgIcon";
import IconRTL from "./icons/IconRTL";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Font Awesome Icon", FontAwesomeIconCode, FontAwesomeIcon),
		paneComponent("Material Icon", MaterialIconCode, MaterialIcon),
		paneComponent("SVG Icon", SvgIconCode, SvgIcon),
		paneComponent("Icon RTL Behavior", IconRTLCode, IconRTL),
	];

	return (
		<Pane
			components={components}
			muiApi="icon"
			muiComponent="icons"
			{...props}
		/>
	);
};